<template>
  <footer id="footer">
    <div class="contact">
      <a href="mailto:obchod@katerinahorak.cz" title="obchod@katerinahorak.cz">
        <strong>Mail:</strong> obchod@katerinahorak.cz
      </a>
      <a href="https://www.facebook.com/khg.katerinahorak" title="https://www.facebook.com/khg.katerinahorak">
        <strong>Facebook:</strong> khg.katerinahorak
      </a>
      <a href="https://www.instagram.com/katerinagoryczka/" title="https://www.instagram.com/katerinagoryczka/">
        <strong>Instagram:</strong> katerinagoryczka
      </a>
      <a href="katerinahorak.cz-obchodni-podminky.pdf" title="Obchodní podmínky." target="_blank">
        <strong>Obchodní podmínky</strong> ke stažení.
      </a>
    </div>
    <div class="copyright">Kateřina Horák Goryczka, katerinahorak.cz 2021 - všechna práva vyhrazena.</div>

  </footer>
</template>
<script>
export default {
  name: "theFooter",
  components: {}
};
</script>
